import { useContext,useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { SUCURSAL_ORIGEN } from 'Constants'
import { printPDF } from 'Helpers'
import { interfaces } from 'service/interfaces'

import { FieldsDest } from './Destinat'
import { FieldsInfGral } from './InfGral'

const Shipment = (props) => {
  const { data, setData, dataBefore } = props
  const [edit] = useContext(EditContext)
  const [isLoading, setIsLoading] = useState(false)

  const [tab, setTab] = useState(0)
  const createDismissableSnackbar = useCustomSnackbar()

  const origenEncontrado = SUCURSAL_ORIGEN.find(
    (sucursal) => sucursal.label === data.infoMain.origen
  )
  const empresaId = origenEncontrado ? origenEncontrado.id : null

  const handleChange = (name, value) => {
    setData({
      ...data,
      shipping: {
        ...data.shipping,
        [name]: name === 'bultos' ? Number(value) : value,
      },
    })
  }

  const handleChangeDest = (name, value) => {
    setData((prevData) => ({
      ...prevData,
      shipping: {
        ...prevData.shipping,
        destinatario: {
          ...prevData.shipping.destinatario,
          [name]: value,
        },
      },
    }))
  }

  async function print() {
    const values = {
      empresa: empresaId,
      pedido: data.infoMain.id,
    }
    setIsLoading(true)
    await interfaces.salesOrders
      .printShipping(values)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar('Presupuesto impreso con éxito!', {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal', {
          variant: 'error',
        })
      })
    setIsLoading(false)
  }

  const classes = useStyles()

  function renderTabs(index) {
    switch (index) {
      case 0:
        return (
          <>
            <InputsWithoutValidate
              fields={FieldsInfGral(data.shipping, handleChange, edit, dataBefore)}
              spacing={2}
            />

            <div className={classes.buttons}>
              <CustomButton
                buttonEnd
                style={{
                  marginLeft: '1.5rem',
                  backgroundColor: '#e0e0e0',
                  color: '#4B4B4B',
                }}
                text="Imprimir"
                onClick={print}
                disabled={
                  isLoading ||
                  !data.shipping.sucursal ||
                  data.shipping.envio === null ||
                  data.shipping.envio === undefined ||
                  !data.shipping.transporte1 ||
                  !data.shipping.bultos ||
                  !data.shipping.nro_seguimiento
                }
              />
            </div>
          </>
        )
      case 1:
        return (
          <InputsWithoutValidate
            fields={FieldsDest(data, handleChangeDest, edit, dataBefore)}
            spacing={2}
          />
        )
      default:
        break
    }
  }

  const verticalTabs = [
    {
      id: 0,
      title: 'Información general',
    },
    {
      id: 1,
      title: 'Destinatario',
    },
  ]

  return (
    <div>
      <ContentWithSubTabs
        listVerticalTabs={verticalTabs}
        value={tab}
        setValue={setTab}
        children={<div style={{ margin: '20px' }}>{renderTabs(tab)}</div>}
      />
    </div>
  )
}

export default Shipment
